import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-grid-range-header',
    styles: [':host { width: 100%; }'],
    template: `
        <div class="left">{{params.title}}</div>
        <div class="right">{{params.count()}}</div>
    `,
    changeDetection: ChangeDetectionStrategy.Default
})
export class RangeHeaderComponent implements AgRendererComponent {
    params: any;

    constructor() {}

    agInit(params: any) {
        this.params = params;  
    }

    refresh(): boolean {
        return true;
    }
}
